import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { ExperienceInput } from 'sr-types/lib/person/v1/graphql';
import { FormProvider } from '../../../common/form/FormContext';
import I18n from '../../../common/i18n/I18n';
import { professionalExperiencesValidationRules, validateDateRange } from '../../person';
import ProfessionalExperiencesModal from './ProfessionalExperiencesModal';

export default ({
    isAddExperiencesModalOpen,
    createState,
    existingState,
    setCreateState,
    onSave,
    onClose,
    isSaving
}: {
    isAddExperiencesModalOpen: boolean;
    createState: ExperienceInput;
    existingState: ExperienceInput;
    setCreateState: Dispatch<SetStateAction<ExperienceInput>>;
    onSave: () => void;
    onClose: () => void;
    isSaving: boolean;
}) => {
    const [validationRules, setValidationRules] = useState({ ...professionalExperiencesValidationRules });

    useEffect(() => {
        if (createState && createState.dateRange) {
            const validation = { ...professionalExperiencesValidationRules };
            const startProp = 'dateRange.start';
            const endProp = 'dateRange.end';

            const startDate = createState.dateRange.start;
            const endDate = createState.dateRange.end;

            validateDateRange(validation, startDate, endDate, startProp, endProp);

            setValidationRules(validation);
        }
    }, [createState]);

    return (
        <FormProvider state={createState} setState={setCreateState} validationRules={validationRules}>
            <ProfessionalExperiencesModal
                isAddExperiencesModalOpen={isAddExperiencesModalOpen}
                onSave={onSave}
                onClose={onClose}
                isSaving={isSaving}
                title={
                    <I18n token={`person.professional.experience.form.modal.title.${existingState ? 'edit' : 'add'}`} />
                }
            />
        </FormProvider>
    );
};
